/**
 * T-d1: what is wrong with the telephony, as a code and translated keys. The
 * raw SDK or server text ("Internal server error") is never shown; the code
 * is, so support can tell the cases apart.
 */
export type TelephonyIssueCode = 'MIC_DENIED' | 'MIC_UNSUPPORTED' | 'TOKEN_FAILED' | 'TEL_OFFLINE' | 'TEL_NOT_READY';

/** The codes the device itself reports (TwilioDeviceContext.deviceErrorCode). */
export type DeviceErrorCode = Extract<TelephonyIssueCode, 'TOKEN_FAILED' | 'TEL_OFFLINE'>;

export interface TelephonyIssue {
  code: TelephonyIssueCode;
  titleKey: string;
  descriptionKey: string;
}

const KEYS: Record<TelephonyIssueCode, { titleKey: string; descriptionKey: string }> = {
  MIC_UNSUPPORTED: { titleKey: 'dialer:telephonyBlocker.unsupportedBrowser.title', descriptionKey: 'dialer:telephonyBlocker.unsupportedBrowser.description' },
  MIC_DENIED: { titleKey: 'dialer:telephonyBlocker.micBlocked.title', descriptionKey: 'dialer:telephonyBlocker.micBlocked.description' },
  TOKEN_FAILED: { titleKey: 'dialer:telephonyBlocker.tokenFailed.title', descriptionKey: 'dialer:telephonyBlocker.tokenFailed.description' },
  TEL_OFFLINE: { titleKey: 'dialer:telephonyBlocker.notConnected.title', descriptionKey: 'dialer:telephonyBlocker.notConnected.description' },
  TEL_NOT_READY: { titleKey: 'dialer:telephonyBlocker.notReady.title', descriptionKey: 'dialer:telephonyBlocker.notReady.description' },
};

/**
 * What the modal shows when a session could not start (DEVICE_NOT_READY).
 * The device may still be starting (permission not answered yet, register in
 * flight): no blocking issue is known, but the click must still be answered.
 */
export function telephonyIssueOnStart(current: TelephonyIssue | null): TelephonyIssue {
  return current ?? { code: 'TEL_NOT_READY', ...KEYS.TEL_NOT_READY };
}

/**
 * Null while nothing blocks calls. 'unknown' permission and a 'registering'
 * device are transient and do not count.
 */
export function telephonyIssue(input: {
  micPermissionStatus: string;
  deviceState: string;
  deviceErrorCode?: DeviceErrorCode | null;
}): TelephonyIssue | null {
  let code: TelephonyIssueCode | null = null;
  if (input.micPermissionStatus === 'unsupported') code = 'MIC_UNSUPPORTED';
  else if (input.micPermissionStatus === 'denied') code = 'MIC_DENIED';
  else if (input.deviceState === 'error') code = input.deviceErrorCode ?? 'TEL_OFFLINE';
  return code ? { code, ...KEYS[code] } : null;
}

/** Event that opens the telephony modal when a session cannot start. */
export const TELEPHONY_REQUIRED_EVENT = 'revcall:telephony-required';
